export type WhatsAppTemplateCategoryType = {
  id: number
  name: string
  value: string
}

export const WhatsAppTemplateCategories: WhatsAppTemplateCategoryType[] = [
  {id: 1, name: 'WHATSAPP_TEMPLATE_BUILDER.CATEGORY_JOURNEY_LABEL', value: 'JOURNEY'},
  {id: 2, name: 'WHATSAPP_TEMPLATE_BUILDER.CATEGORY_RTN_LABEL', value: 'RTN'},
]
